import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RecentClassificationDto } from '../model/classification-history/recent-classification.dto';
import { RecentClassification } from '../model/classification-history/recent-classification.model';
import { ClassifierMessage } from '../model/mail-classifier/classifier-message.model';

@Injectable({
  providedIn: 'root',
})
export class ClassificationHistoryService {
  constructor(private httpClient: HttpClient) {}

  getRecentClassifiedEmails(recentClassificationDto: RecentClassificationDto): Observable<RecentClassification> {
    const url = `${environment.newApiBaseUrl}/classification-history/classification/get-recent-classification`;

    return this.httpClient.post<RecentClassification>(url, recentClassificationDto);
  }

  getClassifiedEmail(messageHandlerId: string): Observable<ClassifierMessage> {
    const url = `${environment.newApiBaseUrl}/classification-history/classification/${messageHandlerId}`;

    return this.httpClient.get<ClassifierMessage>(url);
  }
}
